<template lang="pug">
.m-grid
  .m-grid-title 轻量化监控
  .m-grid-form
    el-form(inline, size="small")
      el-form-item(label="项目来源")
        el-input(v-model="searchForm.prjName", placeholder="请输入项目名称", @change="getList()")
      el-form-item(label="文件类型")
        el-select(v-model="searchForm.lightFileFormats", multiple, clearable, @change="getList()")
          el-option(v-for="{ id, cnName } in dicts.format", :key="id", :value="id", :label="cnName")
      el-form-item(label="轻量化状态")
        el-select(v-model="searchForm.statusList", multiple, clearable, @change="getList()")
          el-option(v-for="{ id, cnName } in dicts.status", :key="id", :value="id", :label="cnName")
      el-form-item(label="上传人")
        el-input(v-model="searchForm.checkInUser", placeholder="请输入账号、姓名检索", @change="getList()")
      el-form-item(label="文件上传时间")
        el-date-picker(v-model="searchForm.createTime", type="daterange", value-format="yyyy-MM-dd", @change="getList()")
      el-form-item
        el-input(v-model="searchForm.fileName", placeholder="输入文件名", size="small", prefix-icon="el-icon-search", @change="getList()", clearable)
      el-button(size="small", type="primary", @click="getList()") 查询
      el-button(v-if="page.totalCount", size="small", type="primary", @click="batchLight(2)") 一键所有轻量化
      el-button(v-if="selection.length", size="small", type="primary", @click="batchLight(1)") 批量轻量化
  .m-grid-table
    el-table.jy-table(:data="list", size="mini", height="100%", @selection-change="setSelection", @sort-change="sortChange")
      el-table-column(type="selection", width="50px", align="center")
      el-table-column(label="文件名称", prop="fileName", min-width="100px", max-width="300px", show-overflow-tooltip)
      el-table-column(v-slot="{ row: { statusName } }", label="轻量化状态", prop="statusName", width="100px")
        span.status-name(:data-status-name="statusName") {{ statusName }}
      el-table-column(label="项目名称", prop="prjName", min-width="150px")
      el-table-column(v-slot="{ row: { fileVersion } }", label="版本", align="center", width="80px", show-overflow-tooltip) v{{ fileVersion }}
      el-table-column(label="上传时间", prop="checkInDate", sortable="custom", align="center", width="150px")
        template(v-slot="{ row: { checkInDate } }") {{ checkInDate | date }}
      el-table-column(v-slot="{ row }", label="文件路径", show-overflow-tooltip, min-width="200px")
        a.m-link(href="javascript:;", @click="toProject(row)") {{ row.filePath }}
      el-table-column(label="失败原因", prop="errorMessage", min-width="100px")
      el-table-column(v-slot="{ row }", label="操作", width="130px")
        a.m-link(href="javascript:;", @click="download(row)") 下载
  .m-grid-footer
    el-pagination(
      background,
      :current-page.sync="page.pageNum",
      :page-size="page.pageSize",
      :total="page.totalCount",
      :page-sizes="sizes",
      layout="total, sizes, prev, pager, next, jumper",
      @current-change="getList",
      @size-change="getList(1, $event)"
    )
</template>
<script>
import { toProjectDoc } from "@/CommonDP/utils/docPublic";
import { pageList, lightDicList, batchLightWeight, lightFormatsDicList } from "./api.js";
import dayjs from "dayjs";
import { downloadFileShowPrompt } from "@/CommonDP/utils/index.js";
import docService from "@/CommonDP/service/doc-service.js";

export default {
  name: "LightFile",
  filters: {
    date(str) {
      return dayjs(str).format("YYYY-MM-DD HH:mm");
    }
  },
  data() {
    return {
      list: [],
      selection: [],
      searchForm: {
        prjName: "",
        lightFileFormats: [],
        statusList: [],
        checkInDateSort: 0, // 默认倒序
        checkInUser: "",
        createTime: [],
        fileName: ""
      },
      page: {
        pageNum: 1,
        pageSize: 15,
        totalCount: 0
      },
      sizes: [5, 10, 15, 20, 30, 40, 50, 100, 200, 300, 400, 500, 1000, 5000],
      dicts: {
        status: [],
        format: []
      }
    };
  },
  computed: {
    searchParams() {
      const {
        searchForm: { createTime, ...form }
      } = this;
      const [checkInStartTime, checkInEndTime] = createTime || [];
      return { ...form, checkInStartTime, checkInEndTime };
    }
  },
  mounted() {
    this.getDict();
    this.getList();
  },
  methods: {
    sortChange({ prop, order }) {
      const propMap = { checkInDate: "checkInDateSort" };
      const filterKey = propMap[prop];
      if (filterKey) {
        this.searchForm[filterKey] = order === "ascending" ? 1 : 0;
        this.getList(1);
      }
    },
    async download({ fileId, prjId, fileVersion: version, fileName }) {
      const res = await docService.downloadFile(prjId, fileId, version);
      downloadFileShowPrompt(fileName, res);
    },
    // 跳转项目文旦
    async toProject(row) {
      const {
        folderList: [..._list],
        prjId
      } = row;
      if (prjId && _list.length) {
        const list = [];
        for (const item of _list) {
          list.push({ folderId: item.folderId });
          const sub = item.subFolderList;
          sub && _list.push(...sub);
        }
        toProjectDoc(list, prjId);
      } else {
        this.$message.warning("不支持跳转");
      }
    },

    getDict() {
      lightDicList().then(({ data }) => {
        this.dicts.status = data.map(({ status: id, statusName: cnName }) => ({ id, cnName }));
      });
      lightFormatsDicList().then(({ data }) => {
        this.dicts.format = data.map((item) => ({ id: item, cnName: item }));
      });
    },
    async getList(index = 1, size = this.page.pageSize) {
      const { searchParams } = this;
      const params = { ...searchParams, pageNum: index, pageSize: size };
      const { data, pageIndex, pageSize, totalCount } = await pageList(params);
      this.list = data || [];
      this.page.totalCount = totalCount;
      this.page.pageNum = pageIndex;
      this.page.pageSize = pageSize;
    },
    setSelection(list) {
      this.selection = list;
    },
    async batchLight(type) {
      const params = {};
      switch (type) {
        case 1:
          Object.assign(params, { fileIdList: this.selection.map(({ fileId }) => fileId) });
          break;
        case 2:
          Object.assign(params, this.searchParams);
          break;
        default:
          return;
      }
      await this.$confirm("确定轻量化?", "提示");
      await batchLightWeight(params);
      await this.getList(1);
    }
  }
};
</script>
<style lang="scss" scoped src="./index.scss">
</style>
